import {initWebComponent} from "@/helpers/web-component-helper";
import {initFileUpload} from "@/helpers/file-upload-helper";

const template = document.createElement('template');

export class FormFileUploadComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const attributeID = this.getAttribute('data-attribute-id')
        const key = this.getAttribute('data-key')
        const wizardItem = window.wizardItem[key]

        const totalFiles = wizardItem.ActionAdvanced

        template.innerHTML = `
        <div class="dropzone" id="divNotificationFileUpload">
            <div class="dz-message" data-dz-message>
              <label class="btn btn-primary btn-sm">
                <span class="fa fa-cloud-download-alt"></span> Bestand toevoegen / <span class="fa fa-camera ml-1"></span> Open de camera
              </label>
              <div class="mt-2 text-primary">
              Kies uit maximaal ${totalFiles} bestanden
              (video of foto), maximale grootte 32 mb per bestand
              </div>
            </div>
          </div>`

        initWebComponent(this, template)

        initFileUpload(attributeID, totalFiles)
    }
}
